import React, { useState, useEffect } from 'react'
import './resignation.css'
import { Link } from 'react-router-dom'
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { useForm, Controller } from 'react-hook-form';
import profile from '../../../assets/profile.png'
import { useDispatch, useSelector } from 'react-redux'
import {getAllUsers} from '../../../api'
import {handleStaffs} from '../../../state/userSlice'
import {handleAddResign} from '../../../state/resignSlice'
import moment from 'moment';
import {handleOpenModal, handleCloseModal} from '../../../state/modalSlice'
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import Loader from '../../../components/loader/Loader'
import ActionCell from '../../../components/actionCell/ActionCell'
import {fetchResignations, resignation, updateResignations} from '../../../api/resignApi'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content';

// Create a SweetAlert2 instance with React integration
const MySwal = withReactContent(Swal);


function ExpandableCell({ value }) {
    const [expanded, setExpanded] = useState(false);
  
    return (
        <div style={{display: 'flex',flexDirection: 'column'}}>
            <div dangerouslySetInnerHTML={{__html: expanded ? value 
                : (value?.length > 70 ? value?.slice(0, 70)+'...' 
                : value?.slice(0, 70))}}>
            </div>
            {value?.length > 100 && (
            <button
                className="request__status-table_btn"
                type="button"
                onClick={() => setExpanded(!expanded)}
            >
                {expanded ? 'view less' : 'view more'}
            </button>
            )}
        </div>
    );
}

const columns = [
    {
        field: 'name',
        headerName: 'Name',
        width: 250,
        renderCell: (param)=>{
            return (
                <div className='resignation__table-profile'>
                    <img src={param.row.img} 
                    alt="" className="resignation__table-img" />
                    <div className="resignation__table-profile_list">
                        <h4 className="resignation__table-profile_name">
                            {param?.row?.user?.firstName + ' ' + param?.row?.user?.lastName}
                        </h4>
                        <span className="resignation__table-profile_email">
                            {param?.row?.user?.email}
                        </span>
                    </div>
                </div>
            )
        }
    },
    {
        field: 'department',
        headerName: 'Department',
        width: 150,
        renderCell: (param) => (
            <span>
                {param?.row?.user?.department}
            </span>
        )
    },
    {
        field: 'reasons',
        headerName: 'Reasons',
        width: 170,
        renderCell: (param) => <ExpandableCell value={param?.row?.reasons}/>
    },
    {
        field: 'noticeDate',
        headerName: 'Notice Date',
        width: 150,
        renderCell: (param) => (
            <span>
                {moment(param?.row?.noticeDate).format('DD MMMM YYYY')}
            </span>
        )
    },
    {
        field: 'resignDate',
        headerName: 'Resignation Date',
        width: 140,
        renderCell: (param) => (
            <span>
                {moment(param?.row?.resignDate).format('DD MMMM YYYY')}
            </span>
        )
    },
    {
        field: 'action',
        headerName: 'Action',
        width: 100,
        renderCell: (param) => <ActionCell param={param} />
    },
];

const rows = [
    {
        id: 1,
        name: 'Ricardo Day',
        email: 'ogbu@vuk.us',
        img: profile,
        department: 'ACCOUNT',
        reason: `many stood plane factor try hearing social construction 
        fifteen graph slightly garden cook surprise replied block future 
        made receive third lead pie saved establish`,
        noticeDate: '12/25/2089',
        resignDate: '10/17/2062',
    },
    {
        id: 2,
        name: 'Mabelle Cooper',
        email: 'wed@cagak.af',
        img: profile,
        department: 'TICKET',
        reason: `many stood plane factor try hearing social construction 
        fifteen graph slightly garden cook surprise replied block future 
        made receive third lead pie saved establish`,
        noticeDate: '12/25/2089',
        resignDate: '10/17/2062',
    },
    {
        id: 3,
        name: 'Gilbert Daniels',
        email: 'conunvi@okusi.cg',
        img: profile,
        department: 'SOCIAL MEDIA',
        reason: `many stood plane factor try hearing social construction 
        fifteen graph slightly garden cook surprise replied block future 
        made receive third lead pie saved establish`,
        noticeDate: '12/25/2089',
        resignDate: '10/17/2062',
    },
    {
        id: 4,
        name: 'Jeremiah Beck',
        email: 'tieha@esureb.gt',
        img: profile,
        department: 'IT',
        reason: `many stood plane factor try hearing social construction 
        fifteen graph slightly garden cook surprise replied block future 
        made receive third lead pie saved establish`,
        noticeDate: '12/25/2089',
        resignDate: '10/17/2062',
    },
    {
        id: 5,
        name: 'Christina Reeves',
        email: 'sowoefi@en.sd',
        img: profile,
        department: 'VISA',
        reason: `many stood plane factor try hearing social construction 
        fifteen graph slightly garden cook surprise replied block future 
        made receive third lead pie saved establish`,
        noticeDate: '12/25/2089',
        resignDate: '10/17/2062',
    },
    
];

const AddResignation = ({user, staffs, closeModal, handleGetResignation, modal}) => {
    const [isLoading, setIsLoading] = useState(false)
    const {
        register,
        handleSubmit,
        formState: {errors},
        reset,
        control
    } = useForm({
        mode: 'onChange',
        defaultValues: modal?.data ? modal?.data : ''
    })
    

    const onSubmit = async (data) => {
        setIsLoading(true)
        try{
            const res = await (modal?.data ? updateResignations(user?.token, data, modal?.data?._id) : resignation(user?.token, data)) 
            if(res?.success){
                MySwal.fire({
                    icon: 'success',
                    title: res?.message,
                    showConfirmButton: false,
                    timer: 2000
                });
                reset()
                handleGetResignation()
                closeModal()
            }else{
                MySwal.fire({
                    icon: 'error',
                    title: res?.message,
                    showConfirmButton: false,
                    timer: 2000
                });
            }
            setIsLoading(false)
        }catch(error){
            console.log(error)
            setIsLoading(false)
            MySwal.fire({
                icon: 'error',
                title: "There's an error processing your request, Try again",
                showConfirmButton: false,
                timer: 2000
            });
        }
    }

    return (
        <div className="modal" onClick={closeModal}>
            <div className="modal-content" onClick={(e)=>e.stopPropagation()}>
                <div className="modal-heading">
                    <h4 className="modal-title">Add Resignation</h4>
                    <button type='button' onClick={closeModal}
                    className="modal-btn">
                        <i class='bx bx-x'></i>
                    </button>
                </div>
                <form className="modal-form" onSubmit={handleSubmit(onSubmit)}>
                    <div className="modal-field">
                        <label htmlFor="staff" className='modal-label'>
                            Staff <span>*</span>
                        </label>
                        <select name="staff" className="modal-input"
                        {...register('staff',{required: 'This field is required!'})}>
                            <option value="" disabled>Select a staff</option>
                            {
                                staffs?.map((item, i)=>(
                                    <option value={item?._id} key={i}>
                                        {`${item?.firstName} ${item?.lastName}`}
                                    </option>
                                ))
                            }
                        </select>
                        {errors?.staff && (
                            <span className="modal-error">{errors?.staff?.message}</span>
                        )}
                    </div>
                    <div className="modal-items">
                        <div className="modal-field">
                            <label htmlFor="noticeDate" className='modal-label'>
                                Notice Date <span>*</span>
                            </label>
                            <input type="date" name='noticeDate' className="modal-input" 
                            {...register('noticeDate',{required: 'This field is required!'})}/>
                            {errors?.noticeDate && (
                                <span className="modal-error">{errors?.noticeDate?.message}</span>
                            )}
                        </div>
                        <div className="modal-field">
                            <label htmlFor="resignDate" className='modal-label'>
                                Resignation Date <span>*</span>
                            </label>
                            <input type="date" name='resignDate' className="modal-input" 
                            {...register('resignDate',{required: 'This field is required!'})}/>
                            {errors?.resignDate && (
                                <span className="modal-error">{errors?.resignDate?.message}</span>
                            )}
                        </div>
                    </div>
                    <div className="modal-field" style={{width: '100%'}}>
                        <label htmlFor="reasons" className='modal-label'>
                            Reason <span>*</span>
                        </label>
                        <Controller
                            name="reasons"
                            control={control}
                            defaultValue=""
                            rules={{required: 'This field is required'}}
                            render={({ field }) => (
                            <ReactQuill
                                name="reasons"
                                theme="snow"
                                value={field.value}
                                onChange={(content) => field.onChange(content)}
                                style={{minWidth: '100% !important'}}
                            />
                            )}
                        />
                        {errors?.reasons && (
                            <span className="modal-error">{errors?.reasons?.message}</span>
                        )}
                    </div>
                    <div className="modal-field bottom">
                        {
                            isLoading ? <Loader/> : <button type='submit'
                            className='modal-button button'>
                                Submit
                            </button>
                        }
                    </div>
                </form>

            </div>
        </div>
    )
}

const Resignation = () => {
    const {user, staffs} = useSelector((state)=>state.user)
    const {resignation} = useSelector((state)=>state.resignation)
    const {modal} = useSelector((state)=>state.modal)
    const [value, setValue] = useState('')
    const dispatch = useDispatch()

    const openModal = () =>{
        dispatch(handleOpenModal())
    }
    const closeModal = () =>{
        dispatch(handleCloseModal())
    }

    const handleFetchUsers = async () => {
        try{
            const res = await getAllUsers(user?.token)
            dispatch(handleStaffs(res?.data))
        }catch(error){
            console.log(error)
        }
    }

    const handleGetResignation = async () =>{
        try{
            const res = await fetchResignations(user?.token)
            dispatch(handleAddResign(res?.data))
        }catch(error){
            console.log(error)
        }
    }

    useEffect(()=>{
        handleGetResignation()
        handleFetchUsers()
    },[])

    const filterItems = resignation?.filter((item)=>{
        return item?.user?.firstName?.toLowerCase().includes(value.toLowerCase())
        || item?.user?.lastName?.toLowerCase().includes(value.toLowerCase())
        || item?.user?.email?.toLowerCase().includes(value.toLowerCase())
    })
  return (
    <section className='resignation'>
        {/* HEADING */}
        <div className="heading">
            <div className="heading__box">
                <div className="heading-item">
                    <h3 className="heading-title">Resignation | </h3>
                    <i class='bx bx-home heading__title-icon'></i>
                    <Link to="/" className="heading-text">
                        Home <i class='bx bx-chevron-right heading-icon'></i>
                    </Link>
                    <span className="heading-text">
                        resignation <i class='bx bx-chevron-right heading-icon'></i>
                    </span>
                </div>
                <p className="heading-text">
                    View resignations
                </p>
            </div>
            <button 
            onClick={openModal}
            className="heading__box-btn button">
                Add Resignation
            </button>
        </div>

        <div className="resignation__container">
            <div className="resignation__search">
                <h4 className="resignation__search-title">Resignation</h4>
                <div className="resignation__search-box">
                    <span className="resignation__search-span">Search:</span>
                    <input type="text" placeholder="Name or email..."
                    value={value} onChange={(e)=>setValue(e.target.value)}
                    className='resignation__search-input'/>
                </div>
            </div> 

            <div className="resignation__table">
                <DataGrid
                    getRowId={(rows => rows._id)}
                    rows={filterItems ?? []}
                    columns={columns}
                    initialState={{
                    pagination: {
                        paginationModel: {
                        pageSize: 5,
                        },
                    },
                    }}
                    pageSizeOptions={[5]}
                    checkboxSelection
                    disableRowSelectionOnClick
                    getRowHeight={() => 'auto'} 
                    sx={{
                        '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': {
                            py: 0.5,
                        },
                        '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': {
                            py: '5px',
                        },
                        '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': {
                            py: '10px',
                        },
                    }}
                    experimentalFeatures={{ lazyLoading: true }}
                />
            </div>
        </div>
        {modal?.show && <AddResignation 
        user={user}
        staffs={staffs}
        modal={modal}
        closeModal={closeModal}
        handleGetResignation={handleGetResignation}/>}
    </section>
  )
}

export default Resignation